import { create } from 'zustand';
import axios from 'axios';

const CONFIGURED_URL = process.env.REACT_APP_BACKEND_URL || '';
const isCustomDomain = typeof window !== 'undefined' && 
  CONFIGURED_URL && 
  !window.location.origin.includes('preview.emergentagent.com') &&
  !window.location.origin.includes('localhost');
const API_URL = isCustomDomain ? '' : CONFIGURED_URL;

const authStore = create((set, get) => ({
  user: null,
  loading: false,
  error: null,

  setUser: (user) => set({ user }),

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, { email, password }, { timeout: 15000 });
      localStorage.setItem('session_token', response.data.session_token);
      try {
        const meRes = await axios.get(`${API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${response.data.session_token}` },
          timeout: 10000
        });
        set({ user: meRes.data, loading: false });
        return meRes.data;
      } catch {
        const basicUser = {
          user_id: response.data.user_id,
          email: response.data.email,
          name: response.data.name,
          user_type: response.data.user_type || 'seeker'
        };
        set({ user: basicUser, loading: false });
        return basicUser;
      }
    } catch (error) {
      set({ error: error.response?.data?.detail || 'Errore durante il login', loading: false });
      throw error;
    }
  },

  register: async (name, email, password, userType = 'seeker', showEmail = true, showPhone = true) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/api/auth/register`, {
        name, email, password, user_type: userType, terms_accepted: true, show_email: showEmail, show_phone: showPhone
      });
      set({ loading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.detail || 'Errore durante la registrazione', loading: false });
      throw error;
    }
  },

  verifyEmail: async (email, code) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/api/auth/verify-email`, { email, code });
      set({ user: response.data, loading: false });
      localStorage.setItem('session_token', response.data.session_token);
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.detail || 'Codice non valido', loading: false });
      throw error;
    }
  },

  resendCode: async (email) => {
    try {
      const response = await axios.post(`${API_URL}/api/auth/resend-code`, { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  logout: async () => {
    try {
      const token = localStorage.getItem('session_token');
      await axios.post(`${API_URL}/api/auth/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      set({ user: null });
      localStorage.removeItem('session_token');
    } catch (error) {
      set({ user: null });
      localStorage.removeItem('session_token');
    }
  },

  fetchCurrentUser: async () => {
    set({ loading: true });
    try {
      const token = localStorage.getItem('session_token');
      if (!token) {
        set({ loading: false });
        return;
      }
      const response = await axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      set({ user: response.data, loading: false });
    } catch (error) {
      set({ user: null, loading: false });
      localStorage.removeItem('session_token');
    }
  },

  googleLogin: async (sessionId) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/api/auth/session`, 
        { session_id: sessionId }
      );
      localStorage.setItem('session_token', response.data.session_token);
      try {
        const meRes = await axios.get(`${API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${response.data.session_token}` }
        });
        set({ user: meRes.data, loading: false });
        return meRes.data;
      } catch {
        set({ user: response.data, loading: false });
        return response.data;
      }
    } catch (error) {
      set({ error: error.response?.data?.detail || 'Errore durante il login con Google', loading: false });
      throw error;
    }
  }
}));

export default authStore;
